import { CardActions, CardActionsProps } from '@mui/material'
import { FC } from 'react'

const CardActionsWrapper: FC<CardActionsProps> = ({ ...props }) => <CardActions {...props} />

export default CardActionsWrapper
